var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.6 2.217c1.16 0 2.101.94 2.101 2.1v1.9h1.9c1.16 0 2.1.94 2.1 2.1v11.2a2.1 2.1 0 0 1-2.1 2.1h-7.2a2.1 2.1 0 0 1-2.1-2.1v-1.9H6.4a2.1 2.1 0 0 1-2.1-2.1v-11.2c0-1.16.94-2.1 2.1-2.1zm-3.199 5.4a.7.7 0 0 0-.7.7v11.2a.7.7 0 0 0 .7.7h7.2a.7.7 0 0 0 .7-.7v-11.2a.7.7 0 0 0-.7-.7zm-4-4a.7.7 0 0 0-.7.7v11.2a.7.7 0 0 0 .7.7h1.9v-7.9c0-1.16.94-2.1 2.1-2.1h3.9v-1.9a.7.7 0 0 0-.7-.7z",
  clipRule: "evenodd"
})));
export default SvgCopy;